import { PICS_URL } from "api";
import AddOrLinkButton from "components/AddOrLinkButton";
import InputSelect from "components/InputSelect";
import Counter2 from "components/counter2";
import CalculatorPackichQuote from "components/quote/packich_quote";
import { ROUTES_PATHS } from 'const';
import { useStores } from "hooks/useStores";
import { format_price } from "js/utils";
import React, { useEffect, useRef, useState } from "react";
import Price from './components/Price';

const Bag = () => {
  const [count, setCount] = useState(1);
  const [countPacks, setCountPacks] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFetchedAdd, setIsFetchedAdd] = useState(false);
  const [items, setItems] = useState({});
  const [fetch, setFetch] = useState(1);
  const [material, setMaterial] = useState(1);
  const [defaultMaterial, setDefaultMaterial] = useState(1);
  const [thickness, setThickness] = useState(1);
  const [defaultThickness, setDefaultThickness] = useState(1);
  const [volume, setVolume] = useState(1);
  const [defaultVolume, setDefaultVolume] = useState(1);
  const [packageType, setPackageType] = useState(1);
  const [defaultPackageType, setDefaultPackageType] = useState(1);
  const [isAdd, setIsAdd] = useState(false);

  const { api } = useStores();

  useEffect(() => {
    setIsLoaded(false);
    setIsLoadedPP(false);
    api.catalog
      .getTrashBagCalc({
        material: material,
        volume: volume,
        package_type: packageType,
        thickness: thickness,
      })
      .then((response) => {
        setItems(response);
        for (let item of response.material) {
          if (item.is_active === true) {
            setDefaultMaterial(item);
          }
        }
        for (let item of response.thickness) {
          if (item.is_active === true) {
            setDefaultThickness(item);
          }
        }
        for (let item of response.volume) {
          if (item.is_active === true) {
            setDefaultVolume(item);
          }
        }
        for (let item of response.package_type) {
          if (item.is_active === true) {
            setDefaultPackageType(item);
          }
        }
        setIsLoaded(true);
      });
  }, [fetch]);

  const materialHandler = (value) => {
    setMaterial(value.value);
    setFetch(fetch + 1);
    setCount(items.multiplicity);
    setCountPacks(1);
    restartButton();
  };

  const thicknessHandler = (value) => {
    setThickness(value.value);
    setFetch(fetch + 1);
    setCount(items.multiplicity);
    setCountPacks(1);
    restartButton();
  };

  const volumeHandler = (value) => {
    setVolume(value.value);
    setFetch(fetch + 1);
    setCount(items.multiplicity);
    setCountPacks(1);
    restartButton();
  };

  const packageTypeHandler = (value) => {
    setPackageType(value.value);
    setFetch(fetch + 1);
    setCount(items.multiplicity);
    setCountPacks(1);
    restartButton();
  };

  const [fetchPP, setFetchPP] = useState(1);
  const [isLoadedPP, setIsLoadedPP] = useState(false);
  const [color, setColor] = useState(1);
  const [defaultColor, setDefaultColor] = useState(1);
  const [grade, setGrade] = useState(1);
  const [defaultGrade, setDefaultGrade] = useState(1);
  const [width, setWidth] = useState(1);
  const [defaultWidth, setDefaultWidth] = useState(1);
  const [length, setLength] = useState(1);
  const [defaultLength, setDefaultLength] = useState(1);

  const mounted = useRef(true);
  useEffect(() => {
    if (mounted.current) {
      // do componentDidMount logic
      mounted.current = false;
    } else {
      // do componentDidUpdate logic
      setIsLoaded(false);
      setIsLoadedPP(false);
      api.catalog
        .getPpBagCalc({
          color: color,
          grade: grade,
          width: width,
          length: length,
        })
        .then((response) => {
          setItems(response);
          for (let item of response.color) {
            if (item.is_active === true) {
              setDefaultColor(item);
            }
          }
          for (let item of response.grade) {
            if (item.is_active === true) {
              setDefaultGrade(item);
            }
          }
          for (let item of response.width) {
            if (item.is_active === true) {
              setDefaultWidth(item);
            }
          }
          for (let item of response.length) {
            if (item.is_active === true) {
              setDefaultLength(item);
            }
          }
          setIsLoadedPP(true);
        });
    }
  }, [fetchPP]);

  const colorHandler = (value) => {
    setColor(value.value);
    setFetchPP(fetchPP + 1);
    restartButton();
    resetCounters();
  };

  const gradeHandler = (value) => {
    setGrade(value.value);
    setFetchPP(fetchPP + 1);
    restartButton();
    resetCounters();
  };

  const widthHandler = (value) => {
    setWidth(value.value);
    setFetchPP(fetchPP + 1);
    restartButton();
    resetCounters();
  };

  const lengthHandler = (value) => {
    setLength(value.value);
    setFetchPP(fetchPP + 1);
    restartButton();
    resetCounters();
  };

  const resetCounters = () => {
    setCount(items.multiplicity);
    setCountPacks(1);
  };

  const radioHandler = (e) => {
    let radio1 = document.querySelector("#radio-1");
    let radio2 = document.querySelector("#radio-2");

    if (e.target.id === "radio-1" && isLoaded === true) {
      return;
    } else if (e.target.id === "radio-2" && isLoadedPP === true) {
      return;
    }
    if (radio1.checked === true) {
      setFetch(fetch + 1);
      document.querySelector(".calc-right__title").innerHTML = "Мусорные мешки";
    } else if (radio2.checked === true) {
      setFetchPP(fetchPP + 1);
      document.querySelector(".calc-right__title").innerHTML = "ПП мешки";
    }
    resetCounters();
    restartButton();
  };

  const resetHandler = () => {
    document.querySelector("#radio-1").checked = true;
    resetCounters();
    setWidth(1);
    setLength(1);
    setGrade(1);
    setColor(1);
    setMaterial(1);
    setVolume(1);
    setPackageType(1);
    setFetch(fetch + 1);
    setIsAdd(false);
  };

  const restartButton = () => {
    setIsAdd(false);
  };

  useEffect(() => {
    if (isLoaded) {
      setCount(items.multiplicity);
    }
  }, [isLoaded]);

  useEffect(() => {
    if (isLoadedPP) {
      setCount(items.multiplicity);
    }
  }, [isLoadedPP]);

  const [isLoadedCounters, setIsLoadedCounters] = useState(false);
  const [restartCounters, setRestartCounters] = useState(1);

  useEffect(() => {
    setIsLoadedCounters(true);
  }, [restartCounters]);

  const countRef = useRef(true);
  useEffect(() => {
    if (countRef.current) {
      // do componentDidMount logic
      countRef.current = false;
    } else {
      // do componentDidUpdate logic
      if (count === 0) {
        setCount(items.multiplicity);
        return;
      }
      if (count / items.in_pack_count === countPacks) {
        return;
      }
      setCountPacks(Math.ceil(count / items.in_pack_count));
      setIsLoadedCounters(false);
      setRestartCounters(restartCounters + 1);
    }
  }, [count]);

  const countPackRef = useRef(true);
  useEffect(() => {
    if (countPackRef.current) {
      // do componentDidMount logic
      countPackRef.current = false;
    } else {
      // do componentDidUpdate logic
      setCount(countPacks * items.in_pack_count);
      setIsLoadedCounters(false);
      setRestartCounters(restartCounters + 1);
    }
  }, [countPacks]);

  const postItem = () => {
    setIsFetchedAdd(true);
    api.cart
      .postCartItem({
        product_article: items.article,
        item_quantity: count,
        package_quantity: countPacks,
      })
      .then(() => changeBasketCount())
      .finally(() => {
        setIsFetchedAdd(false);
        setIsAdd(true);
      });
  };

  const changeBasketCount = () => {
    api.cart
      .getCartItems()
      .then((response) => {
        let counters = document.querySelectorAll(".basket-counter");
        for (let counter of counters) {
          counter.innerText = String(response.length);
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
        }
      });
  };

  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  useEffect(() => {
    if (isLoaded) {
      setMinPrice(format_price(items.min_price));
      setMaxPrice(format_price(items.max_price));
    }
  }, [isLoaded]);

  useEffect(() => {
    if (isLoadedPP) {
      setMinPrice(format_price(items.min_price));
      setMaxPrice(format_price(items.max_price));
    }
  }, [isLoadedPP]);


  let slideIndex = 1;
  function showSlides(slideIndex) {
    let sliderSize = document.querySelector(".how-gallery-slider").clientWidth;
    const slides = document.querySelectorAll(
      ".how-gallery-slider__slides-item"
    );
    for (let slide of slides) {
      slide.style.transform = `translateX(-${(slideIndex - 1) * sliderSize}px)`;
    }

    const dots = document.querySelectorAll(".controls-dots-dot");
    for (let dot of dots) {
      dot.classList.remove("controls-dots-dot-active");
    }
    dots[slideIndex - 1].classList.add("controls-dots-dot-active");
  }

  useEffect(() => {
      if (document.querySelectorAll(".controls-dots-dot").length !== 0) {
        const dots = document.querySelectorAll(".controls-dots-dot");
        if (dots.length === 1) {
          document.querySelector(
            ".how-gallery-slider__controls"
          ).style.display = "none";
        }
        dots[0].classList.add("controls-dots-dot-active");
        for (let i = 0; i < dots.length; i++) {
          const dot = dots[i];
          dot.addEventListener("click", () => {
            slideIndex = i + 1;
            showSlides(slideIndex);
          });
        }
        let backBtn = document.querySelector("#backBtn");
        backBtn.addEventListener("click", back);
        let frvBtn = document.querySelector("#frvBtn");
        frvBtn.addEventListener("click", frv);
      }
  }, []);

  const back = () => {
      const dots = document.querySelectorAll(".controls-dots-dot");
      if (slideIndex === 1) {
        slideIndex = dots.length;
      } else {
        slideIndex -= 1;
      }
      showSlides(slideIndex);
  };

  const frv = () => {
      const dots = document.querySelectorAll(".controls-dots-dot");
      if (slideIndex === dots.length) {
        slideIndex = 1;
      } else {
        slideIndex += 1;
      }
      showSlides(slideIndex);
  };
  return (
    <div className='calculator-main-content-calc'>
      <div className='calc-setings'>
        <div className='calc-settings-wrap'>
          <ul className='calc-settings__list'>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title radio-title'>Вид:</p>
              <div className='calc-settings__list-item-setting radio-settings-wrap'>
                <div className='radio-settings'>
                  {isLoaded || isLoadedPP ? (
                    <>
                      <div className='form_radio'>
                        <input
                          id='radio-1'
                          type='radio'
                          name='radio'
                          value='1'
                          onClick={(e) => radioHandler(e)}
                          defaultChecked={isLoaded}
                        />
                        <label htmlFor='radio-1'>Мусорные мешки</label>
                      </div>
                      <div className='form_radio'>
                        <input
                          id='radio-2'
                          type='radio'
                          name='radio'
                          value='1'
                          onClick={(e) => radioHandler(e)}
                          defaultChecked={isLoadedPP}
                        />
                        <label htmlFor='radio-2'>ПП мешки</label>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='radio-loader' />
                      <div className='radio-loader' />
                    </>
                  )}
                </div>
              </div>
            </li>
            {isLoaded ? (
              <>
                <li className='calc-settings__list-item'>
                  <p className='calc-settings__list-item-title'>Тип:</p>
                  <div className='calc-settings__list-item-setting'>
                    <InputSelect
                      defaultValue={defaultMaterial}
                      options={items.material}
                      onchangeInput={materialHandler}
                    />
                  </div>
                </li>
                <li className='calc-settings__list-item'>
                  <p className='calc-settings__list-item-title'>Объем, л:</p>
                  <div className='calc-settings__list-item-setting'>
                    <InputSelect
                      defaultValue={defaultVolume}
                      options={items.volume}
                      onchangeInput={volumeHandler}
                    />
                  </div>
                </li>
                <li className='calc-settings__list-item'>
                  <p className='calc-settings__list-item-title'>
                    Толщина, мкм:
                  </p>
                  <div className='calc-settings__list-item-setting'>
                    <InputSelect
                      defaultValue={defaultThickness}
                      options={items.thickness}
                      onchangeInput={thicknessHandler}
                    />
                  </div>
                </li>
                <li className='calc-settings__list-item'>
                  <p className='calc-settings__list-item-title'>
                    Тип упаковки:
                  </p>
                  <div className='calc-settings__list-item-setting'>
                    <InputSelect
                      defaultValue={defaultPackageType}
                      options={items.package_type}
                      onchangeInput={packageTypeHandler}
                    />
                  </div>
                </li>
              </>
            ) : null}
            {isLoadedPP ? (
              <>
                <li className='calc-settings__list-item'>
                  <p className='calc-settings__list-item-title'>Цвет:</p>
                  <div className='calc-settings__list-item-setting'>
                    <InputSelect
                      defaultValue={defaultColor}
                      options={items.color}
                      onchangeInput={colorHandler}
                    />
                  </div>
                </li>
                <li className='calc-settings__list-item'>
                  <p className='calc-settings__list-item-title'>Сорт:</p>
                  <div className='calc-settings__list-item-setting'>
                    <InputSelect
                      defaultValue={defaultGrade}
                      options={items.grade}
                      onchangeInput={gradeHandler}
                    />
                  </div>
                </li>
                <li className='calc-settings__list-item'>
                  <p className='calc-settings__list-item-title'>Ширина, см:</p>
                  <div className='calc-settings__list-item-setting'>
                    <InputSelect
                      defaultValue={defaultWidth}
                      options={items.width}
                      onchangeInput={widthHandler}
                    />
                  </div>
                </li>
                <li className='calc-settings__list-item'>
                  <p className='calc-settings__list-item-title'>Длина, см:</p>
                  <div className='calc-settings__list-item-setting'>
                    <InputSelect
                      defaultValue={defaultLength}
                      options={items.length}
                      onchangeInput={lengthHandler}
                    />
                  </div>
                </li>
              </>
            ) : null}
            {!isLoaded && !isLoadedPP ? (
              <>
                {[...Array(4)].map((el, i) => (
                  <div
                    key={i}
                    className='input-loader'
                    style={{ margin: "32px 0" }}
                  />
                ))}
              </>
            ) : null}
            {(!isLoaded && !isLoadedPP) || items.in_pack_count === 1 ? null : (
              <li className='calc-settings__list-item'>
                <p className='calc-settings__list-item-title'>
                  {items.page_data.package_count_text !== ""
                    ? items.page_data.package_count_text
                    : "Количество, уп:"}
                </p>
                {isLoadedCounters ? (
                  <Counter2
                    id={"counter1"}
                    onChange={setCountPacks}
                    count={countPacks}
                    multiplicity={items.multiplicity}
                    packages={true}
                    minCount={1}
                    step={1}
                    restart={restartButton}
                  />
                ) : null}
              </li>
            )}
            {isLoaded || isLoadedPP ? (
              <li className='calc-settings__list-item'>
                <p className='calc-settings__list-item-title'>
                  {items.page_data.count_text !== ""
                    ? items.page_data.count_text
                    : "Количество, шт:"}
                  {items.in_pack_count === 1 ? null : (
                    <span className='tooltip'>
                      <span className='tooltiptext'>
                        {items.page_data.package_count_hint !== ""
                          ? items.page_data.package_count_hint
                          : `1 упаковка = ${items.in_pack_count} штук(и)`}
                      </span>
                    </span>
                  )}
                </p>
                {isLoadedCounters ? (
                  <Counter2
                    id={"counter2"}
                    onChange={setCount}
                    count={count}
                    minCount={items.multiplicity}
                    step={items.multiplicity}
                    multiplicity={items.multiplicity}
                    restart={restartButton}
                  />
                ) : null}
              </li>
            ) : null}
            <li className='calc-settings__list-item mobile-list-item'>
              <p className='calc-settings__list-item-title'>Наличие:</p>
              {isLoaded || isLoadedPP ? (
                items.in_stock == "в наличии" ||
                items.in_stock == "В наличии" ? (
                  <div className='calc-settings__list-item-setting settings-stock'>
                    {items.in_stock}
                  </div>
                ) : (
                  <div className='calc-settings__list-item-setting settings-outOfStock'>
                    {items.in_stock}
                  </div>
                )
              ) : null}
            </li>
            <Price minPrice={minPrice} maxPrice={maxPrice} />
            <li className='calc-settings__list-item calc-border'>
              <div className='calc-settings-border'></div>
            </li>
            <li className='calc-settings__list-item calc-cart'>
              <button
                className='calc-settings__button-reset'
                onClick={resetHandler}
              >
                <div className='button-reset-icon'></div>
                <div className='button-reset-title'>Сбросить</div>
              </button>
              <AddOrLinkButton
                isAdd={isAdd}
                postItem={postItem}
                isFetchedAdd={isFetchedAdd}
              />
            </li>
          </ul>
        </div>
      </div>
      <div className='calc-right'>
        <div className='calc-right__content'>
          {items.image ? (
            <div className='calc-right__img'>
              <img loading="lazy" src={PICS_URL + items.image} alt={items.title || ''} />
            </div>
          ) : null}
          <h3 className='calc-right__title'>Мусорные мешки</h3>
          <table className='calc-right__table'>
            <tbody>
              {isLoaded ? (
                <>
                  <tr>
                    <th>Артикул</th>
                    <td>{items.article}</td>
                  </tr>
                  <tr>
                    <th>Техническое название</th>
                    <td>{items.title}</td>
                  </tr>
                  <tr>
                    <th>Нагрузка, кг</th>
                    <td>{items.load}</td>
                  </tr>
                </>
              ) : null}
              {isLoadedPP ? (
                <>
                  <tr>
                    <th>Артикул</th>
                    <td>{items.article}</td>
                  </tr>
                  <tr>
                    <th>Техническое название</th>
                    <td>{items.title}</td>
                  </tr>
                  <tr>
                    <th>Вес 1шт, г</th>
                    <td>{items.weight}</td>
                  </tr>
                  <tr>
                    <th>Грузоподъемность, кг</th>
                    <td>{items.lifting_capacity}</td>
                  </tr>
                </>
              ) : null}
            </tbody>
          </table>
          {items?.page_data?.pak_pakych_quote ? (
            <CalculatorPackichQuote
              text={items.page_data.pak_pakych_quote.text}
              bgColor={items.page_data.pak_pakych_quote.bg_color}
              borderColor={items.page_data.pak_pakych_quote.border_color}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Bag;
